const getProperty = (value: unknown, key: string): unknown => {
  if (typeof value !== "object" || value === null) return undefined;
  return (value as Record<string, unknown>)[key];
};

/**
 * Normalize API / axios errors into a user-facing string.
 * Handles FastAPI `detail`, Nexus `context.message`, and plain `message`.
 */
export const extractDataTransferError = (
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string => {
  const data = getProperty(getProperty(error, "response"), "data");

  const detail = getProperty(data, "detail");
  if (typeof detail === "string" && detail.trim()) return detail.trim();
  if (Array.isArray(detail)) {
    const joined = detail
      .map((item: unknown) => {
        if (typeof item === "string") return item;
        return (
          getProperty(item, "msg") ??
          getProperty(item, "message") ??
          JSON.stringify(item)
        );
      })
      .filter(Boolean)
      .join("; ");
    if (joined) return joined;
  }

  const contextMessage = getProperty(getProperty(data, "context"), "message");
  if (typeof contextMessage === "string" && contextMessage.trim()) {
    return contextMessage.trim();
  }

  const dataMessage = getProperty(data, "message");
  if (typeof dataMessage === "string" && dataMessage.trim()) {
    return dataMessage.trim();
  }

  const axiosMessage = getProperty(error, "message");
  if (typeof axiosMessage === "string" && axiosMessage.trim()) {
    return axiosMessage.trim();
  }

  return fallback;
};
